module.exports = __webpack_public_path__ + "assets/bike_dark.d20e5872.svg";